import React, { memo, useEffect, useRef, useState } from 'react';

/** 单次 SSE 增量超过此阈值时，用打字动画追赶而非瞬间展示 */
const SSE_IMMEDIATE_DELTA = 48;

const StreamText = memo(({ content = '' }) => {
  const [visible, setVisible] = useState('');
  const targetRef = useRef(content);
  const timerRef = useRef(null);

  useEffect(() => {
    targetRef.current = content;

    if (!content) {
      setVisible('');
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      return undefined;
    }

    setVisible((prev) => {
      if (!prev || !content.startsWith(prev)) {
        return '';
      }

      const delta = content.length - prev.length;
      if (delta > 0 && delta <= SSE_IMMEDIATE_DELTA) {
        return content;
      }

      return prev;
    });

    const tick = () => {
      setVisible((prev) => {
        const target = targetRef.current;
        if (!target) return '';
        if (prev.length >= target.length) return target;

        const remaining = target.length - prev.length;
        const step = remaining > 200
          ? Math.max(2, Math.ceil(remaining / 40))
          : remaining > 80
            ? Math.max(2, Math.ceil(remaining / 24))
            : remaining > 24
              ? Math.max(1, Math.ceil(remaining / 10))
              : 1;

        return target.slice(0, Math.min(target.length, prev.length + step));
      });
    };

    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(tick, 24);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [content]);

  const typing = visible.length < content.length;

  return (
    <div className="chat-stream-text">
      {visible}
      {typing && <span className="stream-cursor" aria-hidden="true" />}
    </div>
  );
});

StreamText.displayName = 'StreamText';

export default StreamText;
